import { createBrowserHistory } from 'history'
// history object was installed with react-router-dom

export default createBrowserHistory();